import React from "react";
import {
  Card,
  Button,
  Modal,
  MarketingLayout,
  SectionHelper,
  Text,
  Layout,
  Cell,
  CustomModalLayout,
  Box,
  Loader,
  Divider,
  FormField,
  Checkbox,
  Input
} from '@wix/design-system';

import { DownloadImportSmall } from '@wix/wix-ui-icons-common';

import { passCsrfToken } from '../../util/helpers'
import axios from 'axios'

class Orders extends React.Component {

  state = {
    config:  this.props.configData,
    loading: false,
    modalImportConfirm: false,
  };

  componentDidMount = () => {
    passCsrfToken(document, axios);
  }

  validateForm = () => {
    var hasErrors = false;
    if (this.state.config.use_sftp_transfer === true) {
      if (this.state.config.sftp_host.length < 1) {
      hasErrors = true;
      }

      if (this.state.config.sftp_login.length < 1) {
      hasErrors = true;
      }

      if (this.state.config.sftp_password.length < 1) {
      hasErrors = true;
      }

      if (this.state.config.sftp_port < 1) {
      hasErrors = true;
      }

      if (this.state.config.sftp_remote_path.length < 1) {
      hasErrors = true;
      }
    }

    return !hasErrors;
  };

  validateFormSmtp = () => {
    var hasErrors = false;
    if (this.state.config.use_smtp_param === true) {
      if (this.state.config.smtp_host.length < 1) {
      hasErrors = true;
      }

      if (this.state.config.smtp_login.length < 1) {
      hasErrors = true;
      }

      if (this.state.config.smtp_password.length < 1) {
      hasErrors = true;
      }

      if (this.state.config.smtp_from.length < 1) {
      hasErrors = true;
      }

      if (this.state.config.smtp_port < 1) {
      hasErrors = true;
      }
    }
    return !hasErrors;
  };

  validateEmail = () => {
      return new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.config.smtp_from);
    };

    validateEmailTo = () => {
      return new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.config.smtp_to);
    };

  importOrders = () => {
    this.setState({ modalImportConfirm: true });
  }

  displayModalImport = () => {
    return (
      <Modal
        isOpen={this.state.modalImportConfirm}
        onRequestClose={() => this.setState({ modalImportConfirm: false })}
        shouldCloseOnOverlayClick
        screen="desktop"
      >
        <CustomModalLayout
            primaryButtonText={I18n.t('configs.modal.confirm_import')}
            secondaryButtonText={I18n.t('deposit_list.modal.cancel_button')}
            onCloseButtonClick={() => this.setState({ modalImportConfirm: false })}
            secondaryButtonOnClick={() => this.setState({ modalImportConfirm: false })}
            primaryButtonOnClick={() => this.processImportOrders()}
            title={I18n.t('configs.modal.synchronized_order_title')}
            content={
              <Box direction="vertical" marginBottom="SP2">
                <Text>{I18n.t('configs.modal.confirm_import')}</Text>
              </Box>
            }
        ></CustomModalLayout>
      </Modal>
    );
  }

  processImportOrders = () => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    this.setState({loading: true});
    this.setState({ modalImportConfirm: false });
    /* We import orders */
    axios({
      method: 'post',
      url: '/bulk-import-orders',
      data: {
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({loading: false});
      if (result.data.success == true) {
        this.props.toggleToast( I18n.t('configs.synchronized_order.success_message'), false);
      } else {
        this.props.toggleToast( I18n.t('configs.synchronized_order.error_message'), true);
      }
      this.setState({
        config: { ...this.state.config, ['synchronized_order']: true },
        });
    }).catch(error => {
      this.props.toggleToast( I18n.t('configs.synchronized_order.error_message'), true);
    });
    this.setState({loading: false});
  }

  handleChangeRadio = (field, value) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, [field]: value },
    })
  };

  handleChange = (e) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, [e.target.name]: e.target.value },
    })
  };

  /* Submit FORM */
  handleSubmit = () => {
    this.setState({showNotification: false});
    this.setState({ loadingSaveProcess: true });
        // Check if data is valid
    if (!this.validateForm()) {
      //return if not valid
      this.props.toggleToast(I18n.t('configs.my_account_error'), true);
      this.setState({ loadingSaveProcess: false });
      return;
    }

    if (!this.validateFormSmtp()) {
      //return if not valid
      this.props.toggleToast(I18n.t('configs.my_account_error'), true);
      this.setState({ loadingSaveProcess: false });
      return;
    }

    axios({
    url: this.state.config.id ? '/configs/' + this.state.config.id : '/configs',
    method: this.state.config.id ? 'patch' : 'post',
    data: {
      config: this.state.config,
      instance_id: this.props.shop.instance_id
    },
    }).then(result => {
      if (result.data.success == true) {
        var data = result.data;
        data.config.local_offer = Object.keys(JSON.parse(data.config.local_offer));
        this.setState({ config: data.config });
        this.props.childChange(data.config);
        this.setState({loadingSaveProcess: false});
        //We update general props
        this.props.handleUpdateConfig(false);
        this.props.toggleToast(I18n.t('configs.save_success'), false);
      } else {
        this.setState({loadingSaveProcess: false});
        this.props.toggleToast(I18n.t('configs.save_error'), true);
      }
    }).catch(error => {
      console.log(error);
      this.setState({loadingSaveProcess: false});
      this.props.toggleToast(I18n.t('configs.save_error'), true);
    });
  };

  smtpTesting = () => {
    this.setState({loading: true});

    if (!this.validateEmailTo()) {
      this.props.contentOverlay('messageToast', I18n.t('configs._form.my_account_error_email_to'));
      this.props.contentOverlay('errorToast', true);
      this.props.toggleToast();
      this.setState({ loading: false });
      return;
    }

    axios({
    url: '/smtptest',
        method: 'POST',
        data: {
            smtp_login: this.state.config.smtp_login,
            smtp_password: this.state.config.smtp_password,
            smtp_host: this.state.config.smtp_host,
            smtp_from: this.state.config.smtp_from,
            smtp_port: this.state.config.smtp_port,
            smtp_to: this.state.config.smtp_to,
        },

    })
    .then(result => {
        if (result.data.success == true) {
            this.setState({loading: false});
            this.setState({displayError: false});
            this.props.contentOverlay('messageToast', I18n.t('configs._form.test_api_success'));
            this.props.contentOverlay('errorToast', false);
            this.props.toggleToast();
          } else {
            this.setState({loading: false});
            this.setState({displayError: true});
            this.props.contentOverlay('messageToast', I18n.t('configs._form.test_api_error'));
            this.props.contentOverlay('errorToast', true);
            this.props.toggleToast();
        }
    })
    .catch(error => {
        console.log(error);
        this.setState({loading: false});
        this.setState({displayError: true});
        this.props.contentOverlay('messageToast', I18n.t('configs._form.test_api_error'));
        this.props.contentOverlay('errorToast', true);
        this.props.toggleToast();
    });
  };

    render() {
      const {
        config,
        modalImportConfirm,
        loading
      } = this.state;

      const descriptionSection = (<Box direction="vertical">
              <Box className="carrier">
                <Text size="small">
                  <p>{I18n.t('configs.synchronized_order.help')}</p>
                </Text>
              </Box>
            </Box>
          );

      return (
        <div class="carrier_page">
          <Modal
          screen="desktop"
          isOpen={loading}
        >
          <Loader size="large" />
        </Modal>
          <Layout cols={12}>
            <Cell span={4}>
              <Card>
                <MarketingLayout
                  title={I18n.t('configs.synchronized_order.title')}
                  description={descriptionSection}
                  // description={I18n.t('configs.synchronized_order.help')}
                  size="tiny"
                />
              </Card>
            </Cell>
            <Cell span={8}>
              <Card>
                <Card.Content>
                  {!config.synchronized_order && <SectionHelper fullWidth appearance="standard" title={I18n.t('configs.synchronized_order.title_banner')}>
                      <Text>
                        {I18n.t('configs.synchronized_order.text_banner')}
                      </Text>
                      <br/><br/>
                      <Button onClick={(e) => this.importOrders()}
                        prefixIcon={<DownloadImportSmall />}
                      >
                        {I18n.t('configs.import_orders')}
                      </Button>
                    </SectionHelper>
                  }
                  {config.synchronized_order && <SectionHelper fullWidth title={I18n.t('configs.synchronized_order.title_banner')}>
                      <Text>
                        {I18n.t('configs.synchronized_order.already_text_banner')}
                      </Text>
                    </SectionHelper>
                  }
                </Card.Content>
              </Card>
            </Cell>
          </Layout>
          {modalImportConfirm ? this.displayModalImport() : null}
          <Divider />
          {/* SFTP DISTANT */}
          <Layout cols={12}>
            <Cell span={4}>
              <Card>
                <MarketingLayout
                  title={I18n.t('configs.synchronized_order.title_sftp')}
                  description={I18n.t('configs.synchronized_order.help_text_sftp')}
                  size="tiny"
                />
                <Card.Content>
                  <SectionHelper fullWidth appearance="danger">
                      <Text size="small">
                        {I18n.t('configs.synchronized_order.config_advanced_options')}
                      </Text>
                  </SectionHelper>
                </Card.Content>
              </Card>
            </Cell>
            <Cell span={8}>
              <Card>
                <Card.Content>
                  <Cell>
                    <FormField>
                      <Checkbox
                        checked={config.use_sftp_transfer === true}
                        onChange={() => this.handleChangeRadio('use_sftp_transfer', !config.use_sftp_transfer)}
                        >
                        {I18n.t('configs.synchronized_order.label_use_sftp_transfer')}
                      </Checkbox>
                      {config.use_sftp_transfer === true &&
                        <Cell>
                          <Box marginTop="6px" width="100%" direction="vertical">
                            <Box marginTop="SP2" width="100%">
                              <FormField
                                label={I18n.t('configs.synchronized_order.sftp_host')}
                              >
                                <Input
                                  type="text"
                                  name="sftp_host"
                                  value={config.sftp_host}
                                  onChange={this.handleChange}
                                  status={config.sftp_host !== null && config.sftp_host.length > 0 ? '' : 'error'}
                                  statusMessage={config.sftp_host !== null && config.sftp_host.length > 0 ? '' : I18n.t('configs.synchronized_order.sftp_host_error')}
                                />
                                <Text size="tiny">{I18n.t('configs.synchronized_order.sftp_host_help')}</Text>
                              </FormField>
                            </Box>
                            <Box marginTop="SP2" width="100%">
                              <FormField
                                label={I18n.t('configs.synchronized_order.sftp_port')}
                              >
                                <Input
                                  type="number"
                                  name="sftp_port"
                                  value={config.sftp_port}
                                  onChange={this.handleChange}
                                  status={config.sftp_port !== null && config.sftp_port > 0 ? '' : 'error'}
                                  statusMessage={config.sftp_port !== null && config.sftp_port > 0 ? '' : I18n.t('configs.synchronized_order.sftp_port_error')}
                                />
                              </FormField>
                            </Box>
                            <Box marginTop="SP2" width="100%">
                              <FormField
                                label={I18n.t('configs.synchronized_order.sftp_login')}
                              >
                                <Input
                                  type="text"
                                  name="sftp_login"
                                  value={config.sftp_login}
                                  onChange={this.handleChange}
                                  status={config.sftp_login !== null && config.sftp_login.length > 0 ? '' : 'error'}
                                  statusMessage={config.sftp_login !== null && config.sftp_login.length > 0 ? '' : I18n.t('configs.synchronized_order.sftp_login_error')}
                                />
                              </FormField>
                            </Box>
                            <Box marginTop="SP2" width="100%">
                              <FormField
                                label={I18n.t('configs.synchronized_order.sftp_password')}
                              >
                                <Input
                                  type="password"
                                  name="sftp_password"
                                  value={config.sftp_password}
                                  onChange={this.handleChange}
                                  status={config.sftp_password !== null && config.sftp_password.length > 0 ? '' : 'error'}
                                  statusMessage={config.sftp_password !== null && config.sftp_password.length > 0 ? '' : I18n.t('configs.synchronized_order.sftp_password_error')}
                                />
                              </FormField>
                            </Box>
                            <Box marginTop="SP2" width="100%">
                              <FormField
                                label={I18n.t('configs.synchronized_order.sftp_remote_path')}
                              >
                                <Input
                                  type="text"
                                  name="sftp_remote_path"
                                  value={config.sftp_remote_path}
                                  onChange={this.handleChange}
                                  status={config.sftp_remote_path !== null && config.sftp_remote_path.length > 0 ? '' : 'error'}
                                  statusMessage={config.sftp_remote_path !== null && config.sftp_remote_path.length > 0 ? '' : I18n.t('configs.synchronized_order.sftp_remote_path_error')}
                                />
                                <Text size="tiny">{I18n.t('configs.synchronized_order.sftp_remote_path_help')}</Text>
                              </FormField>
                            </Box>
                          </Box>
                        </Cell>
                      }
                    </FormField>
                  </Cell>
                </Card.Content>
              </Card>
            </Cell>
          </Layout>
          <Divider />
          {/* SMTP RETURN */}
          <Layout cols={12}>
            <Cell span={4}>
              <Card>
                <MarketingLayout
                  title={I18n.t('configs.synchronized_order.title_smtp')}
                  description={I18n.t('configs.synchronized_order.help_text_smtp')}
                  size="tiny"
                />
                <Card.Content>
                  <SectionHelper fullWidth appearance="danger">
                      <Text size="small">
                        {I18n.t('configs.synchronized_order.config_advanced_options')}
                      </Text>
                  </SectionHelper>
                </Card.Content>
              </Card>
            </Cell>
            <Cell span={8}>
              <Card>
                <Card.Content>
                  <Cell>
                    <FormField>
                      <Checkbox
                        checked={config.use_smtp_param === true}
                        onChange={() => this.handleChangeRadio('use_smtp_param', !config.use_smtp_param)}
                        >
                        {I18n.t('configs.synchronized_order.label_use_smtp_param')}
                      </Checkbox>
                      {config.use_smtp_param === true &&
                        <Cell>
                          <Box marginTop="6px" direction="vertical">
                            <Box marginTop="SP2" width="100%">
                              <FormField
                                label={I18n.t('configs.synchronized_order.sftp_host')}
                              >
                                <Input
                                  type="text"
                                  name="smtp_host"
                                  value={config.smtp_host}
                                  onChange={this.handleChange}
                                  status={config.smtp_host !== null && config.smtp_host.length > 0 ? '' : 'error'}
                                  statusMessage={config.sftp_host !== null && config.sftp_host.length > 0 ? '' : I18n.t('configs.synchronized_order.smtp_host_error')}
                                />
                                <Text size="tiny">{I18n.t('configs.synchronized_order.smtp_host_help')}</Text>
                              </FormField>
                            </Box>
                            <Box marginTop="SP2" width="100%">
                              <FormField
                                label={I18n.t('configs.synchronized_order.smtp_port')}
                              >
                                <Input
                                  type="number"
                                  name="smtp_port"
                                  value={config.smtp_port}
                                  onChange={this.handleChange}
                                  status={config.smtp_port !== null && config.smtp_port > 0 ? '' : 'error'}
                                  statusMessage={config.smtp_port !== null && config.smtp_port > 0 ? '' : I18n.t('configs.synchronized_order.smtp_port_error')}
                                />
                                <Text size="tiny">{I18n.t('configs.synchronized_order.smtp_port_help')}</Text>
                              </FormField>
                            </Box>
                            <Box marginTop="SP2" width="100%">
                              <FormField
                                label={I18n.t('configs.synchronized_order.smtp_from')}
                              >
                                <Input
                                  type="email"
                                  name="smtp_from"
                                  value={config.smtp_from}
                                  onChange={this.handleChange}
                                  status={config.smtp_from !== null && config.smtp_from.length > 0 ? '' : 'error'}
                                  statusMessage={config.smtp_from !== null && config.smtp_fromlength > 0 ? '' : I18n.t('configs.synchronized_order.smtp_from_error')}
                                />
                                <Text size="tiny">{I18n.t('configs.synchronized_order.smtp_from_help')}</Text>
                              </FormField>
                            </Box>
                            <Box marginTop="SP2" width="100%">
                              <FormField
                                label={I18n.t('configs.synchronized_order.smtp_login')}
                              >
                                <Input
                                  type="text"
                                  name="smtp_login"
                                  value={config.smtp_login}
                                  onChange={this.handleChange}
                                  status={config.smtp_login !== null && config.smtp_login.length > 0 ? '' : 'error'}
                                  statusMessage={config.smtp_login !== null && config.smtp_login.length > 0 ? '' : I18n.t('configs.synchronized_order.smtp_login_error')}
                                />
                              </FormField>
                            </Box>
                            <Box marginTop="SP2" width="100%">
                              <FormField
                                label={I18n.t('configs.synchronized_order.smtp_password')}
                              >
                                <Input
                                  type="password"
                                  name="smtp_password"
                                  value={config.smtp_password}
                                  onChange={this.handleChange}
                                  status={config.smtp_password !== null && config.smtp_password.length > 0 ? '' : 'error'}
                                  statusMessage={config.smtp_password !== null && config.smtp_password.length > 0 ? '' : I18n.t('configs.synchronized_order.smtp_password_error')}
                                />
                              </FormField>
                            </Box>
                            <Box marginTop="SP2" width="100%">
                              <FormField
                                label={I18n.t('configs.synchronized_order.smtp_domain')}
                              >
                                <Input
                                  type="text"
                                  name="smtp_domain"
                                  value={config.smtp_domain}
                                  onChange={this.handleChange}
                                />
                                <Text size="tiny">{I18n.t('configs.synchronized_order.smtp_domain_help')}</Text>
                              </FormField>
                            </Box>
                            <br/><br/>
                            <Text size="medium" weight="bold">{I18n.t('configs.synchronized_order.test_email_sender')}</Text>
                              <Box marginTop="SP2" direction="vertical" width="100%">
                                <FormField
                                  label={I18n.t('configs.synchronized_order.smtp_to')}
                                >
                                <Input
                                  type="email"
                                  name="smtp_to"
                                  value={config.smtp_to}
                                  onChange={this.handleChange}
                                />
                                <Text size="tiny">{I18n.t('configs.synchronized_order.smtp_to_help')}</Text>
                                </FormField>
                              <br/>
                              </Box>
                              <Button size="small" with="200px" as="button" onClick={() => {this.smtpTesting()}}>{I18n.t('configs.synchronized_order.test_email')}</Button>
                          </Box>
                        </Cell>
                      }
                    </FormField>
                  </Cell>
                </Card.Content>
              </Card>
              <Card>
                <Card.Content>
                  <Cell>
                  </Cell>
                </Card.Content>
              </Card>
            </Cell>
          </Layout>
        </div>
      );
    }
}

export default Orders
